// extracted by mini-css-extract-plugin
export default {"input":"AvatarModal_input__wLxdB"};